import { Button, Form, Input, Modal, Tabs, Switch, Divider, Select } from "antd";
import React, { useEffect, useState } from "react";
import * as Icon from "react-feather";
import { useDispatch } from "react-redux";
import footerLinkService from "../../services/footer-link-service";
import appLoaderAction from "../../redux/action/app-loader-action";
import notifyUtitls from "../../utils/notify-utils";
import EditableTagGroup from "../../components/input/editable-tag-group";
import { LINK_TYPE, VISIBILITY_DEFAULT, VISIBILITY_OPTIONS } from "../../constants/app-constants";
import { FORM_LANG, formText } from "../../constants/form-i18n";
import ContentSelect from "../../components/input/content-select";
import constantService from "../../services/constant-service";

const { Option } = Select;

const defaultValue = {
  serviceLinkImage: null,
  isOpenNewTab: false,
  keywordList: [],
};

const { TabPane } = Tabs;

const langTH = "TH";
const langEN = "EN";

const AddFooterLinkDialog = ({
  isShow,
  onCancel,
  onSaveComplete,
  editData,
}) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [keywordList, setKeywordList] = useState(defaultValue.keywordList);
  const [mainTitleTH, setMainTitleTH] = useState(null);
  const [mainTitleEN, setMainTitleEN] = useState(null);
  const [subFooterLinkLists, setSubFooterLinkLists] = useState([]);
  const [linkStatus, setLinkStatus] = useState(true);
  const [visibility, setVisibility] = useState(VISIBILITY_DEFAULT);
  const [currentLanguage, setCurrentLanguage] = useState(langTH);
  // NMU-562: the news categories a NEWS footer link can point at.
  const [newsTypeList, setNewsTypeList] = useState([]);
  // NMU-444: this dialog keys its tabs by TH/EN rather than 1/2, so the
  // language comes straight off the tab it already tracks.
  const dialogLang = currentLanguage === langEN ? FORM_LANG.EN : FORM_LANG.TH;
  const t = formText(dialogLang);

  useEffect(() => {
    if (!isShow) {
      clearAndInitData();
    }
  }, [isShow]);

  // NMU-562: the same taxonomy the News page filters by, fetched once.
  useEffect(() => {
    async function loadNewsType() {
      try {
        const { newsType } = await constantService.getMenuAndNewsType();
        setNewsTypeList(newsType || []);
      } catch (err) {
        notifyUtitls.error(err);
      }
    }
    loadNewsType();
  }, []);

  useEffect(() => {
          // form.setFieldsValue({
      //   title: editData.title,
      //   url: editData.url,
      //   status: editData.status,
      //   totalView: editData.totalView,
      //   enableNewTab: editData.enableNewTab,
      // });

    if (isShow && editData) {
      //console.log('edit....', editData);
      const { title, subFooterLinkLists, status } = editData;
      setMainTitleTH(title.titleTH);
      setMainTitleEN(title.titleEN);
      setSubFooterLinkLists(initialSubLinkKey(subFooterLinkLists));
      setKeywordList(editData.keywordList ? editData.keywordList : defaultValue.keywordList);
      setLinkStatus(status);
      setVisibility(editData.visibility ? editData.visibility : VISIBILITY_DEFAULT);
      setCurrentLanguage(langTH);
    }

  }, [isShow, editData]);

  const clearAndInitData = ()=>{
    setCurrentLanguage(langTH);
    setKeywordList(defaultValue.keywordList);
    setMainTitleTH(null);
    setMainTitleEN(null);
    setLinkStatus(true);
    setVisibility(VISIBILITY_DEFAULT);
    setSubFooterLinkLists([]);
  }

  const initialSubLinkKey = (subLinkList)=>{
    if (!subLinkList) {
      return [];
    }
    return subLinkList.map((item, index)=>{
        const now = Date.now();
        const newItem = {...item};
        newItem.key = `edit-${index}-${now}`;
        return newItem;
    });
  }

  const onSave = async () => {
    try {
      const values = await form.validateFields();
      try {
        dispatch(appLoaderAction.enable());

        if (!editData) {
          let bean = {
            //footerLinkId: "", // need to recheck with requirement
            title: {
              titleTH: mainTitleTH,
              titleEN: mainTitleEN,
            },
            keywordList: keywordList,
            //url: "", // need to recheck with mouck up
            enableNewTab: false, // need to recheck with mouck up
            status: linkStatus,
            visibility: visibility,
            // NMU-562: the add path used to send only title/url/enableNewTab, so
            // a brand-new link lost its type and its target and came back as a
            // plain URL link. Both paths now describe a row the same way.
            subFooterLinkLists: getSubLinkList(),
            totalView: 0
          };

          await footerLinkService.add({ bean: bean });
        } else {
          // let bean = JSON.parse(JSON.stringify(editData));
          // bean.title = values.title;
          // bean.keywordList = keywordList;
          // bean.url = values.url;
          // bean.enableNewTab = values.enableNewTab;
          // bean.status = values.status;
          // bean.totalView = editData.totalView;
          //await footerLinkService.edit({ bean: bean });

          const bean = {...editData};
          const { title } = bean;

          title.titleTH = mainTitleTH;
          title.titleEN = mainTitleEN;
          bean.subFooterLinkLists = getSubLinkList();
          bean.status = linkStatus;
          bean.visibility = visibility;
          // NMU-450: layer is not edited here; leave the record's own value alone.
          bean.keywordList = keywordList;

          await footerLinkService.edit({ bean });

        }

        dispatch(appLoaderAction.disale());
        notifyUtitls.success(t('successTitle'), t('saveSuccess'));
        onSaveComplete();
      } catch (err) {
        notifyUtitls.error(err);
        dispatch(appLoaderAction.disale());
      }
    } catch (errorInfo) {
      notifyUtitls.warning(t('warningTitle'), t('incompleteForm'));
    }
  };

  const getSubLinkList = ()=> {
    if (!subFooterLinkLists) {
        return [];
    }
    return subFooterLinkLists.map((item)=>{
        const {title, url, enableNewTab, templateId, newsType} = item;
        // NMU-514: same inference as the row renderer, so a link the editor did
        // not touch is saved back with the type it was already behaving as.
        // NMU-561: and no type stays no type — see the row renderer.
        const linkType = item.linkType || (templateId ? LINK_TYPE.CONTENT : url ? LINK_TYPE.URL : null);
        return {
          title,
          // NMU-561: a text-only item — no type, so no target either.
          linkType: linkType || null,
          // Only the side that is in use is sent. Keeping both would leave a
          // stale URL on a link switched to CONTENT, and the frontend prefers
          // the page — so the leftover would be invisible until someone
          // switched back and found an address they had not typed.
          // NMU-562: NEWS is the third side — it carries a news category and
          // neither of the other two.
          templateId: linkType === LINK_TYPE.CONTENT ? templateId || null : null,
          url: linkType === LINK_TYPE.URL ? url || null : null,
          newsType: linkType === LINK_TYPE.NEWS ? newsType || null : null,
          enableNewTab
        }
    });
  }

  const onLangChange = (key) => {
    setCurrentLanguage(key);
  };

  const onChagneMainTitleTH = (event) => {
    setMainTitleTH(event.target.value);
  };

  const onChagneMainTitleEN = (event) => {
    setMainTitleEN(event.target.value);
  };

  const onChangeTitleValue = (index, value)=>{
    const newSubLinkList = [...subFooterLinkLists];
    const currentLink = {...newSubLinkList[index]};
    currentLink['title'][currentLanguage===langTH?'titleTH':'titleEN'] = value;
    newSubLinkList[index] = currentLink;
    setSubFooterLinkLists(newSubLinkList);
  }

  const onChangeInputValue = (index, key, value)=>{
    const newSubLinkList = [...subFooterLinkLists];
    const currentLink = {...newSubLinkList[index]};
    currentLink[key] = value;
    newSubLinkList[index] = currentLink;
    setSubFooterLinkLists(newSubLinkList);
  }

  const renderMainTitle = (lang) => {
    return (
      <Form
        layout="vertical"
        name="add_edit_template_content"
        preserve={false}
        form={form}
        // initialValues={{
        //   status: true,
        // }}
        validateMessages={{
          required: t('required'),
        }}
      >
        <Form.Item
          name={lang === langTH ? "mainTitleTH" : "mainTitleEN"}
          label={lang === langTH ? "ชื่อหัวข้อ" : "Topic Title"}
          key={lang === langTH ? "mainTitleTH" : "mainTitleEN"}
          rules={
            lang === langTH
              ? [
                  {
                    required: true,
                  },
                ]
              : [
                  {
                    required: false,
                  },
                ]
          }
          initialValue={lang === langTH ?mainTitleTH: mainTitleEN}
        >
          {lang === langTH ? (
            <Input
              className="mb-2"
              value={mainTitleTH}
              onChange={onChagneMainTitleTH}
            />
          ) : (
            <Input
              className="mb-2"
              value={mainTitleEN}
              onChange={onChagneMainTitleEN}
            />
          )}
        </Form.Item>
      </Form>
    );
  };

  const onAddSubFooterLink = (e) => {

    const newList = [...subFooterLinkLists];
    
    const key = `new-${Date.now()}`;
    
    const newFootLink = {
      key,
      title: {
        titleTH: null,
        titleEN: null,
      },
      // NMU-514: Internal Content is the default the ticket asks for.
      linkType: LINK_TYPE.CONTENT,
      templateId: null,
      url: null,
      enableNewTab: true,
    };

    newList.push(newFootLink);
    setSubFooterLinkLists(newList);
  };

  const onDeleteSubLink = (index)=>{
    const newList = [...subFooterLinkLists];
    newList.splice(index, 1);
    setSubFooterLinkLists(newList);
  }

  /**
   * NMU-562: news categories grouped under their main groups (NMU-412), the way
   * the News page and the menu editor render them. Flat if the API sends no
   * grouping, so an older service still populates the field.
   */
  const renderNewsType = () => {
    const hasGroups = newsTypeList.some((item) => item.groupValue);

    if (!hasGroups) {
      return newsTypeList.map(({ value, labelTh }) => (
        <Option value={value} key={value}>
          {labelTh}
        </Option>
      ));
    }

    const groups = [];
    const byKey = {};
    newsTypeList.forEach((item) => {
      const key = item.groupValue;
      if (!byKey[key]) {
        byKey[key] = { label: item.groupLabelTh || key, items: [] };
        groups.push(byKey[key]);
      }
      byKey[key].items.push(item);
    });

    return groups.map((group) => (
      <Select.OptGroup label={group.label} key={group.label}>
        {group.items.map(({ value, labelTh }) => (
          <Option value={value} key={value}>
            {labelTh}
          </Option>
        ))}
      </Select.OptGroup>
    ));
  };

  const renderFooterLinkContent = (indexKey) => {
    return subFooterLinkLists.map((item, index) => {
      const { titleTH, titleEN } = item.title;
      const { key, url, enableNewTab, templateId, newsType } = item;
      // NMU-514: links saved before this ticket carry no linkType. Infer it from
      // whether a page was chosen, so an existing URL link keeps showing its URL
      // input rather than opening on an empty content picker.
      //
      // NMU-561: only infer when there is actually a target. A link with neither
      // used to be read as a URL link, which then saved as one and rendered an
      // <a> to an empty address; with the type optional, "neither" is a real
      // answer and means a text-only item.
      const linkType = item.linkType || (templateId ? LINK_TYPE.CONTENT : url ? LINK_TYPE.URL : null);
      //const now = Date.now();

      //console.log('titleTH', titleTH, 'titleEN', titleEN);

      return (
          <div key={`subFooter-${key}`}>
          <Divider orientation="left" plain>
              <h5 className="color-primary-title mb-0">{`${t('itemNo')} ${index+1}`}</h5>
          </Divider>
          {currentLanguage===langTH && (
                <Form.Item 
                  name={`linkTitleTH-${key}`}
                  label={t('linkTitle')}
                  rules={[{required: true}]}
                  initialValue={titleTH}
                >
                  <Input
                    className="pb-1"
                    //defaultValue={titleTH}
                    value={titleTH}
                    onChange={(event)=>onChangeTitleValue(index, event.target.value)}
                    key={index}
                  />
                </Form.Item>
            )
          }
          {currentLanguage===langEN && (
                <Form.Item 
                  name={`linkTitleEN-${key}`}
                  label={'Link Title'}
                  rules={[{required: true}]}
                  initialValue={titleEN}
                >
                  <Input
                    className="pb-1"
                    //defaultValue={titleEN}
                    value={titleEN}
                    onChange={(event)=>onChangeTitleValue(index, event.target.value)}
                    key={index}
                  />
                </Form.Item>
            )
          }
          {/* NMU-514: a footer link points either at a CMS page or at a typed-in
              URL, the same choice Service Link (NMU-470) and the intranet cards
              (NMU-478) already offer. The selector drives which input is shown;
              only the matching one is sent on save. */}
          {/* NMU-561: optional. A footer item saved with no type is plain text
              in the footer, not a link — so the target field below is hidden
              entirely until a type is chosen. */}
          <Form.Item
            label={t('linkType')}
            name={`linkType-${key}`}
            initialValue={linkType}
          >
            <Select
              allowClear
              placeholder={t('linkTypePlaceholder')}
              onChange={(value) => onChangeInputValue(index, 'linkType', value ?? null)}
            >
              <Select.Option value={LINK_TYPE.CONTENT}>{t('linkTypeContent')}</Select.Option>
              <Select.Option value={LINK_TYPE.URL}>{t('linkTypeUrl')}</Select.Option>
              {/* NMU-562: opens the News listing filtered to one category. */}
              <Select.Option value={LINK_TYPE.NEWS}>{t('linkTypeNews')}</Select.Option>
            </Select>
          </Form.Item>
          {!linkType ? null : linkType === LINK_TYPE.CONTENT ? (
            <Form.Item
              label={t('contentField')}
              name={`templateId-${key}`}
              initialValue={templateId}
            >
              <ContentSelect
                placeholder={t('contentPlaceholder')}
                onChange={(value) => onChangeInputValue(index, 'templateId', value)}
              />
            </Form.Item>
          ) : linkType === LINK_TYPE.NEWS ? (
            /* NMU-562: the news category this link filters the listing to, from
               the same taxonomy the News page and the menu editor use. */
            <div id={`footer-news-type-field-${key}`}>
              <Form.Item
                label={t('newsTypeField')}
                name={`newsType-${key}`}
                initialValue={newsType}
              >
                <Select
                  allowClear
                  placeholder={t('linkTypePlaceholder')}
                  onChange={(value) => onChangeInputValue(index, 'newsType', value ?? null)}
                >
                  {renderNewsType()}
                </Select>
              </Form.Item>
            </div>
          ) : (
            <Form.Item
              label="URL"
              name={`url-${key}`}
              initialValue={url}
            >
              <Input
                value={url}
                onChange={(event)=>onChangeInputValue(index, 'url', event.target.value)}
               />
            </Form.Item>
          )}
          <Form.Item
            label={t('openInNewTab')}
            name={`enableNewTab-${key}`}
            initialValue={enableNewTab}
          >
            <Switch checked={enableNewTab} onChange={(checked)=>onChangeInputValue(index, 'enableNewTab', checked)} />
          </Form.Item>
          <div className="text-right mt-4 mb-4">
            <Button key={'submit'+key} type="danger" className="me-2" style={{ minWidth: 30 }} onClick={()=>onDeleteSubLink(index)}>
              <Icon.Trash size={18} />
            </Button>
          </div>
        </div>
      )  
    });
  };

  return (
    <div className="container h-100">
      <div className="title-page">
        <Modal
          title={t(editData ? 'editFooterLink' : 'addFooterLink')}
          centered
          width={750}
          visible={isShow}
          onCancel={onCancel}
          destroyOnClose
          footer={[
            <Button key="submit" type="primary" onClick={onSave}>
              <Icon.Save className="me-2" size={17} />
              {t('save')}
            </Button>,
            <Button key="back" className="btn-gray" onClick={onCancel}>
              {t('cancel')}
            </Button>,
          ]}
        >
          <Form
            layout="vertical"
            name="add_edit_service_link"
            preserve={false}
            form={form}
            initialValues={{ status: true, enableNewTab: true }}
            validateMessages={{
              required: t('required'),
            }}
          >
            <Tabs defaultActiveKey="1" onChange={onLangChange}>
              <TabPane tab={t('tabThai')} key={langTH} forceRender>
                {renderMainTitle(langTH)}
              </TabPane>
              <TabPane tab={t('tabEnglish')} key={langEN} forceRender>
                {renderMainTitle(langEN)}
              </TabPane>
            </Tabs>
            <div className="text-right my-3 mb-5">
              <Button
                id="add-footer-sub-link"
                type="primary"
                className="me-2"
                onClick={onAddSubFooterLink}
              >
                <Icon.Plus className="me-1" size={18} />
              </Button>
            </div>
            <div
              style={{
                height: subFooterLinkLists.length === 0 ? "" : "300px",
                overflowY: "auto",
              }}
            >
              {renderFooterLinkContent()}
            </div>
            <Form.Item label={t('keywords')}>
              <EditableTagGroup onChange={setKeywordList} tags={keywordList} lang={dialogLang} />
            </Form.Item>
            <Form.Item label={t('status')} name="status" initialValue={linkStatus}>
              <Switch checked={linkStatus} onChange={(checked)=>setLinkStatus(checked)} />
            </Form.Item>
            {/*
              NMU-450: no Layer selector here any more. A footer link is common
              data now — which layers it appears in is decided by arranging it on
              the Layer tabs, and the same link can sit in more than one, so a
              single-value field on the record could not express it.
            */}
            <Form.Item label={t('visibility')}>
              <Select value={visibility} onChange={(value) => setVisibility(value)}>
                {VISIBILITY_OPTIONS.map((item) => (
                  <Option key={item.value} value={item.value}>
                    {item.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </div>
  );
};

export default AddFooterLinkDialog;
